/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Success_ToastInputs */

const es_admin_billing_batch_success_toast = /** @type {(inputs: Admin_Billing_Batch_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factura actualizada correctamente`)
};

const en_admin_billing_batch_success_toast = /** @type {(inputs: Admin_Billing_Batch_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice updated successfully`)
};

/**
* | output |
* | --- |
* | "Invoice updated successfully" |
*
* @param {Admin_Billing_Batch_Success_ToastInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_success_toast = /** @type {((inputs?: Admin_Billing_Batch_Success_ToastInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Success_ToastInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_success_toast(inputs)
	return en_admin_billing_batch_success_toast(inputs)
});
export { admin_billing_batch_success_toast as "admin.billing.batch.success_toast" }